import { hederaRestApiUrl, REACT_APP_BACKEND_URL } from './constants';

export function getMirrorBaseUrl(network: string): string {
  if (network in hederaRestApiUrl) {
    return hederaRestApiUrl[network as keyof typeof hederaRestApiUrl];
  }

  return `${REACT_APP_BACKEND_URL}/mirror-proxy/${network}`;
}
